/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-pascal-case */
import { RichTextEditor } from "@mantine/rte";
import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { addBlog } from "../../redux/actions/frontendActions/blogActions";
import Dashboard_top_header from "../utils/Dashboard_top_header";
import Sidebar from "../utils/Sidebar";
const initialState = {
  title: "",
  image: "",
  tagItems: [],
};

function DashboardAddBlog() {
  const { blogSuccessMessage, blogErrorMessage, loader } = useSelector(
    (state) => state.Blog
  );



  

  const dispatch = useDispatch();
  const [state, setState] = useState(initialState);
  const [sidebarHide, setSidebarHide] = useState(false);
  const [tags, setTags] = useState([]);
  const [loadImage, setLoadImage] = useState("");
  // handle sidebar
  const handleSidebarHideAndShow = (e) => {
    setSidebarHide(!sidebarHide);
  };
  // handle image

  const fileHendle = (e) => {
    if (e.target.files.length !== 0) {
      setState({
        ...state,
        [e.target.name]: e.target.files[0],
      });
    }

    const reader = new FileReader();

    reader.onload = () => {
      setLoadImage(reader.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  // handle tags
  const handleKeyDown = (e) => {
    if (e.key !== "Enter") return;
    const value = e.target.value;
    if (!value.trim()) return;
    setTags([...tags, value]);
    setState({
      ...state,
      tagItems: tags,
    });
    e.target.value = "";
  };

  const removeTag = (index) => {
    setTags(tags.filter((el, i) => i !== index));
    setState({
      ...state,
      tagItems: tags,
    });
  };

  // handle input
  const handleInput = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const initialValue = "";
  const [editorvalue, onChange] = useState(initialValue);
  // handle main form

  const handleForm = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", state.title);
    formData.append("description", editorvalue);
    formData.append("image", state.image);
    formData.append("tagItems", state.tagItems);
    dispatch(addBlog(formData));
  };

  useEffect(() => {
    if (blogSuccessMessage) {
      window.location.href = "/admin/dashboard/all-blog";
    }
  }, [blogSuccessMessage]);


  
  return (
    <div className="dashboard-container">
      <div className="navbar-area">
        <Dashboard_top_header
          handleSidebarHideAndShow={handleSidebarHideAndShow}
          sidebarHide={sidebarHide}
        />
      </div>

      <div className="dashboard-main-flex">
        <div className="dashboard-sidebar">
          <Sidebar sidebarHide={sidebarHide} />
        </div>
        <div className="dashboard-item">
          {/* add blog form  */}

          <div className="dashboard-add-portfolio-wrapper">
            <div className="form-box">
              <h2>Add Blog</h2>
              <form onSubmit={handleForm}>
                <div className="form-group">
                  <input
                    onChange={handleInput}
                    type="text"
                    placeholder="add title"
                    name="title"
                    className="form-control"
                  />
                </div>

                {/* <div className="form-group">
                  <textarea
                    onChange={handleInput}
                    type="text"
                    placeholder="Description "
                    name="description"
                    className="form-control"
                  />
                </div> */}

                {/* tags  */}
                <div className="form-group">
                  <div className="tag-input-container">
                    {tags.map((tag, index) => (
                      <div className="tag-item" key={index}>
                        <span className="text">{tag}</span>
                        <span
                          onClick={() => removeTag(index)}
                          className="close"
                        >
                          <FaTimes size={15} />
                        </span>
                      </div>
                    ))}

                    <input
                      onChange={handleInput}
                      onKeyDown={handleKeyDown}
                      type="text"
                      className="tags-input"
                      placeholder="add tags...."
                    />
                  </div>
                </div>
                {/* editor  */}

                <div className="form-group">
                  <RichTextEditor
                    style={{ paddingBottom: "80px" }}
                    placeholder="add blog description"
                    value={editorvalue}
                    onChange={onChange}
                    id="rte"
                  />
                </div>

                <div className="form-group">
                  <input
                    onChange={fileHendle}
                    type="file"
                    name="image"
                    className="form-control"
                  />
                </div>

                {
                     blogErrorMessage.errorMessage &&
                     <div className="form-group error-area">
                  
                {
                 
                  <p>{blogErrorMessage.errorMessage}</p>
                }
                  
                </div>
                }
                
                <div className="form-group button-area">
                  <div className="image">
                    {loadImage ? <img src={loadImage} /> : ""}
                  </div>
                  <button type="submit">
                  
                    {loader ? "Loading":  "Add Megazine"}
                  </button>
                </div>

               
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardAddBlog;
